export default __webpack_public_path__ + "static/media/location_preview_robot_rodeo.44a3ab6f.svg";